/**
 * app.tsx
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */



// Import all the third party stuff
import React from 'react';
import { createRoot } from 'react-dom/client';


import AppGenerated from 'containers/AppGenerated';


const domNode = document.getElementById('app') as HTMLDivElement;
const root = createRoot(domNode);


root.render(<AppGenerated />);


// // Import all the third party stuff
// import React from 'react';
// import { hydrateRoot } from 'react-dom/client';


// import AppGenerated from 'containers/AppGenerated';


// const domNode = document.getElementById('app') as HTMLDivElement;
// const root = hydrateRoot(domNode, <AppGenerated />);


// root.render(<AppGenerated />);

